import React from 'react';
import { FormattedMessage } from 'react-intl';

import FeatureTogglz from '@bibliocommons/feature-togglz';
import { TOGGLZ_FEATURES } from '@bibliocommons/constants-feature-togglz';
import { DetailsContainer } from './Details';
import { AboutTheAuthorContainer } from './AboutTheAuthor';
import { SameSeriesContainer } from './SameSeries';
import { ContainsContainer } from './Contains';
import { SubjectAndGenreContainer } from './SubjectAndGenre';
import { ContributorsContainer } from './Contributors';
import Distinctions from './Distinctions';
import { MediaSummaryContainer } from './MediaSummary';

import './About.scss';

export default class About extends React.PureComponent {
  render() {
    return (
      <section className="cp-bib-about container">
        <div className="row">
          <div className="col-lg-3">
            <h2>
              <FormattedMessage id="about_section" />
            </h2>
          </div>
          <div className="col-lg-7">
            <MediaSummaryContainer />
            <AboutTheAuthorContainer />
            <FeatureTogglz>
              {features => (features.get(TOGGLZ_FEATURES.NERF_BIB_PAGE_DEVELOPMENT) ? <Distinctions /> : null)}
            </FeatureTogglz>
            <SameSeriesContainer />
            <ContributorsContainer />
            <ContainsContainer />
            <SubjectAndGenreContainer />
            <DetailsContainer />
          </div>
        </div>
      </section>
    );
  }
}
